
import { pdMixin } from '@/mixin/pd/pdMixin'
import PdSwiperCmp from '@/components/pd/common/PdSwiperCmp.vue'
import PdUnitCmp from '@/components/pd/common/PdUnitCmp.vue'
import { commonfunc } from '~/mixin/common'
import { groobeeUtil } from '@/mixin/groobeeUtil'

export default {
  components: {
    PdSwiperCmp,
    PdUnitCmp
  },
  mixins: [pdMixin, commonfunc, groobeeUtil],
  props: {
    type: {
      type: String,
      default: ''
    },
    pdNo: {
      type: String,
      default: ''
    },
    param: { // 추천/검색 솔루션 상품 조회 파라메타
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    bunPdList: { // 세트상품 리스트
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    recmPdInfo: { // 그루비 추천상품번호 정보
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      srchForm: {},
      apiBaseUrl: '',
      url: '',
      title: '', // 추천상품 구좌 타이틀
      pdList: [],
      bundleSwiperOpt: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: false,
        slidesPerView: 6,
        spaceBetween: 28
      },
      pdSwiperOptView4: {
        pagination: false,
        slidesPerView: 4,
        slidesPerGroup: 4
      },
      pdSwiperOptView5: {
        pagination: false,
        slidesPerView: 5,
        slidesPerGroup: 5
      },
      totalSize: 0,
      cmmnCdList: [],
      groobeeRecmData: [],
      groobeePdNoList: []
    }
  },
  computed: {
  },
  watch: {
    recmPdInfo: {
      deep: true,
      async handler () {
        if (this.recmPdInfo?.pdRecmNoList?.length > 1) {
          this.pdList = []
          this.srchForm = {
            limit: 21, // 20개 노출인데 20개 이상의 상품이 있는지 파악을 위해 21개 호출
            offset: 0,
            pdNo: this.pdNo,
            recmPdNoList: this.recmPdInfo.pdRecmNoList
          }
          await this.selSrchPdList()
        }
      },
    }
  },
  created () {
  },
  async mounted () {
    switch (this.type) {
      case 'with':
        this.title = '다른 고객이 함께 본 상품'
        this.url = '/ds/recommend/dtlwith'
        this.srchForm = {
          limit: 21, // 20개 노출인데 20개 이상의 상품이 있는지 파악을 위해 21개 호출
          offset: 0,
          pdNo: this.pdNo,
          recmPdNoList: this.recmPdInfo.pdRecmNoList
        }
        break
      case 'whatElse':
        this.title = `이런 ${this.param[0].sctgrNm} 상품은 어때요?`
        this.apiBaseUrl = process.env.API_SSN_BASE_URL2
        this.url = '/GoodsCategorySmall'
        this.srchForm = {
          searchQuery: 'R11',
          exhCtgrNo: this.param[0].sctgrNo,
          pdNo: this.pdNo,
          searchSort: 'inct',
          pageNum: 1,
          cntPerPage: 20
        }
        break
      case 'cheaply' :
        this.title = '다른 고객이 함께 구매한 상품'
        this.apiBaseUrl = process.env.API_SSN_BASE_URL2
        this.url = '/GoodsTogether'
        this.srchForm = {
          searchQuery: 'R12',
          // largeExhCtgrNo: this.param[0].lctgrNo,
          // middleExhCtgrNo: this.param[0].mctgrNo,
          exhCtgrNo: this.param[0].mctgrNo, // 기준 카테고리 소->중으로 변경. 2024-01-09
          pdNo: this.pdNo,
          pageNum: 1,
          cntPerPage: 20
        }
        break
      case 'brand' :
        this.title = '브랜드 상품 모아보기'
        this.url = '/pd/pdr/pdDtl/recommend/brndPd'
        this.srchForm = {
          pdNo: this.pdNo,
          brndCd: this.param.brndCd,
          // pageNum: 1,
          // cntPerPage: 20
        }
        break
      case 'dscvr' :
        this.title = '오늘의 발견'
        this.apiBaseUrl = process.env.API_SSN_BASE_URL2
        this.url = '/SearchContents'
        this.srchForm = {
          searchQuery: 'Q2',
          searchTerm: this.pdNo,
          searchSort: '',
          pageNum: 1,
          cntPerPage: 20,
          ctenTyCd: '01,02,03', // DEV901
          userId: this.$store.getters['session/getMb'].mbEid ? this.$store.getters['session/getMb'].mbEid : '',
        }
        break
    }

    await this.selSrchPdList()
  },
  methods: {

    // 검색솔루션 조회
    async selSrchPdList () {
      if (this.isNotEmpty(this.apiBaseUrl)) {
        await this.$AxiosBuilder
          .params(this.srchForm)
          .baseURL(this.apiBaseUrl)
          .build()
          .get(this.url)
          .then((res) => {
            console.log(this.type, res)
            if (this.type === 'dscvr') {
              // 오늘의 발견 컨텐츠 정보 셋팅
              this.setCtenData(res.data.resultSet.result[0].resultDocuments.splice(0, 20))
              this.totalSize = res.data.resultSet.result[0].totalSize
            } else {
              // 상품 정보 셋팅
              this.setPdData(res.data.resultSet.result[1].resultDocuments)
              this.totalSize = res.data.resultSet.result[1].totalSize
            }
          }).catch((e) => {
            console.log('SCR_PDR_000C_8 selRcmdPdList error : ', this.type, e)
          })
      } else if (this.type === 'brand') {
        await this.$AxiosBuilder
          .data(this.srchForm)
          .build() // FO는 캐시 빌더없음 1시간 60*60*1000 지금은 1분
          .post(this.url)
          .then((res) => {
            console.log(this.type, res.data.data)
            // 상품 정보 셋팅
            this.totalSize = res.data.data.length
            this.setPdData(res.data.data)
          }).catch((e) => {
            console.log('SCR_PDL_000C_8 brndPd error : ', this.type, e)
          })
      } else {
        await this.$AxiosBuilder
          .data(this.srchForm)
          .build()
          .post(this.url)
          .then((res) => {
            // 상품 정보 셋팅
            console.log(this.type, res)
            this.totalSize = res.data.data.length
            this.setPdData(res.data.data.splice(0, 40))
          }).catch((e) => {
            console.log('SCR_PDR_000C_8 selRcmdPdList error : ', this.type, e)
          })
      }
    },

    // 컨텐츠리스트 정보 셋팅
    setCtenData (data) {
      data.forEach((item, idx) => {
        this.pdList.push({
          ...item,
          id: idx.toString(),
          video: item.pdCttSty === '02' ? item.pdImgUrl : '', // todo: video 옵션이 들어가야함
          imgUrl: item.ctenTyCd === '03' ? item.videoFileUrl : item.rpsImgFileUrl, // 컨텐츠 이미지
          ctenId: item.ctenId, // 컨텐츠 아이디
          ctenSj: item.ctenSj, // 컨텐츠 제목
          profImgUrl: item.intrImgFileUrl, // 프로필 이미지
          mbNknmNm: item.mbNknmNm, // 유저 닉네임
          inct: item.inct, // 조회수
          ctenTyCd: item.ctenTyCd, // 콘텐츠 타입
          hofAdptYn: item.hofAdptYn, // 에디터 픽 여부
          cn: item.cn, // 유저 작성 글
          txtLength: item.txtLength, // 긴글:1, 짧은글:2
          isLike: false, // 검색솔루션에서 회원별 개인화정보를 수집하지 않으므로 N으로 고정(AJ으로 변경예정)
          isZzim: false, // isLike와 동일하게 N으로 고정
          crew: false, // todo: 확인필요
          best: '', // todo: 확인필요(best image url)
          onlSclCd: this.isNotEmpty(item.ONL_SCL_CD) ? item.ONL_SCL_CD : ''// GTM 작업을 위한 파라미터 추가
        })
      })
    },

    // 상품리스트 정보 셋팅
    setPdData (data) {
      data.forEach((item, idx) => {
        this.pdList.push({
          ...item,
          id: idx.toString(),
          best: item.BESTYN === 'Y', // 베스트 상품 여부
          video: item.pdCttSty === '02' ? item.pdImgUrl : '', // todo: video 옵션이 들어가야함
          imgUrl: item.pdImgUrl + '/dims/optimize/dims/resize/255x340', // 상품 대표이미지 url
          sleStsCd: item.sleStsCd, // 판매상태
          pdPrc: item.pdPrc, // 상품가격
          pdNo: item.pdNo, // 품번
          exhPdNm: item.exhPdNm, // 품명
          bundle: item.bunYn === 'Y', // 세트상품 여부
          onlyPkup: item.pkupDdcatYn === 'Y', // 픽업전용
          onlyOnlYn: item.onlyOnlYn === 'Y', // 택배전용
          newPdYn: item.newPdYn === 'Y', // 신상품
          soldout: item.soldOutYn === 'Y', // 품절여부(검색엔진 제공 품절 여부)
          soldPlan: (item.sleStsCd === '02' && item.wrhParmDt !== '') ? item.wrhParmDt : '', // 판매예정일
          revwAvg: parseFloat(item.avgStscVal) > 0 ? item.avgStscVal : '', // 리뷰평점
          revwCnt: this.isNotEmpty(item.revwCnt) ? Number(item.revwCnt.replace(/[^0-9]/g, '')) : 0, // 리뷰갯수
          totOrQy: this.isNotEmpty(item.totOrQy) ? Number(item.totOrQy.replace(/[^0-9]/g, '')) : 0, // 주문수량
          buyLmtAgeCd: item.buyLmtAgeCd, // 구매제한 연령 코드
          most: false, // 최다리뷰여부
          optPdYn: item.optPdYn === 'Y', // 옵션여부
          emblmUrl: this.isNotEmpty(item.emblm) ? item.emblm.emblmPcImgAtchFileUrl : '', // 엠블럼 pc url
          emblmNm: this.isNotEmpty(item.emblm) ? item.emblm.emblmNm : '', // 엠블럼 이름
          pdAnc: false, // 검색엔진에서 본인이 알람 신청한 내역을 가져올 수 없음
          pdTy: item.pdTy, // 상품타입
          onlSclCd: this.isNotEmpty(item.ONL_SCL_CD) ? item.ONL_SCL_CD : item.onlSclCd, // GTM 작업을 위한 파라미터 추가
          jpQy: this.isNotEmpty(item.jpQy) ? item.jpQy : item.JP_QY,
          mappBoxPdNo: this.isNotEmpty(item.MAPP_BOX_PD_NO) ? item.MAPP_BOX_PD_NO : item.mappBoxPdNo
        })

        if (this.type === 'with') {
          this.groobeePdNoList.push({
            goodsCd: item.pdNo
          })
        }
      })

      if (this.groobeePdNoList.length > 0) {
        const temp = {
          algorithmCd: this.recmPdInfo?.algorithmCd,
          campaignKey: this.recmPdInfo?.campaignKey,
          pdRecmNoList: this.recmPdInfo?.pdRecmNoList
        }

        this.groobeeRecmData = temp

        this.sendGroobee('prod', this.groobeeRecmData.algorithmCd, this.groobeeRecmData.campaignKey, this.groobeePdNoList, 'DI')
      }
    },

    // 추천셋 메뉴 이동
    moveLink (type) {
      // store/ds/persisted.js
      const { pageNum, cntPerPage, ...rest } = this.srchForm
      const rcmdParams = { ...rest, groobeeRecmData: this.groobeeRecmData ?? 'undefind' }
      const params = type === 'rcmd'
        ? {
            searchApi: {}, // 검색 솔루션 쿼리정보
            recmApi: rcmdParams, // 추천 솔루션 옵션정보
            exhCmptmtInfo: {
              hdcpy: this.title, // 구좌명
              exhMtrlRgMthdCd: '30', // 구좌 리스트 조회(10 : 전시파트 수기등록, 20 : 검색솔루션, 30: 추천솔루션)
              insdYn: 'Y', // api 구분(Y : 전시파트 수기등록 or 추천솔루션, N : 검색솔루션)
              url: process.env.API_BASE_URL + this.url, // 도메인 포함 솔루션 url 정보 (ex. env.API_BASE_URL + api url)
              recmPdNoList: this.type === 'with' ? this.groobeeRecmData.pdRecmNoList : [],
              groobeeRecmData: this.type === 'with' ? this.groobeeRecmData : {}
            }
          }
        : {
            searchApi: rest, // 검색 솔루션 쿼리정보
            recmApi: {}, // 추천 솔루션 옵션정보
            exhCmptmtInfo: {
              hdcpy: this.title, // 구좌명
              exhMtrlRgMthdCd: '20', // 구좌 리스트 조회(10 : 전시파트 수기등록, 20 : 검색솔루션, 30: 추천솔루션)
              insdYn: 'N', // api 구분(Y : 전시파트 수기등록 or 추천솔루션, N : 검색솔루션)
              url: process.env.API_SSN_BASE_URL2 + this.url // 도메인 포함 솔루션 url 정보 (ex. env.API_BASE_URL + api url)
            }
          }

      this.$store.dispatch('ds/persisted/updateRendingSet', params).then(() => {
        this.$router.push({ name: 'ds-recmd-id', params: { id: 'C206' } })
      })
      sessionStorage.setItem('preFilterCheck', sessionStorage.getItem('filterCheck'))
      sessionStorage.setItem('filterCheck', [])
    }
  }
}
